// extracted by mini-css-extract-plugin
export default {"payment-frame":"t7mzPbg___payment-frame","paymentFrame":"t7mzPbg___payment-frame","activated":"nr4u67H___activated"};